import { chatUserLastMessageDateTime } from '../../../../utils/dateTimeConverter'

const ChatUserTile = ({ userData, selectedUser }) => {

    return (
        <div className={`flex !p-2 !gap-3 items-center border-b cursor-pointer hover:bg-gray-100 ${selectedUser?._id === userData?._id ? "bg-gray-200" : ""}`}>
            <div className='relative'>
                {userData?.colorCode && <div className='h-3.5 w-3.5 rounded-full absolute -right-1 -top-1' style={{ backgroundColor: userData?.colorCode }}></div>}
                <img src={userData?.profilePic || "https://img.freepik.com/premium-vector/character-avatar-isolated_729149-194801.jpg"} alt="" className='h-9 w-9 object-cover rounded-full' />
            </div>
            <div>
                <p className='text-sm font-semibold break-words'>{userData?.visitorName} | #{userData?.chatSessionCount}</p>
                <p className='text-[10px] text-gray-500 max-line-1 break-words max-w-[100px] overflow-hidden'>{userData?.lastMessage} </p>
                {userData?.visitorOnlineStatus == 1 && <p className='text-[10px] text-green-500'>Online</p>}
            </div>

            <div className='self-start ms-auto text-center'>
                <div className='flex items-center !gap-0.5 mb-0.5'>
                    <div className={`${userData?.status == 2 ? 'bg-green-700' : 'bg-primary'} h-1.5 w-1.5 rounded-full`}></div>
                    <p className={`text-[8px] ${userData?.status == 2 ? 'text-green-700' : 'text-primary'}`}>{chatUserLastMessageDateTime(userData?.createdAt)}</p>
                </div>
                {userData?.unSeenMessageCount > 0 && <p className='ms-auto p-0.5 max-w-4 aspect-square  mb-0 rounded-full leading-none text-white flex items-center justify-center !bg-primary font-semibold text-[9px]'>{userData?.unSeenMessageCount}</p>}
            </div>
        </div>
    )
}

export default ChatUserTile